<template>
  <v-dialog
    v-model="value"
    fullscreen
    transition="fade-transition"
    class="hi-mom"
  >
    <div style="background: white; height: 100%;">
      <v-btn
        flat
        icon
        color="black"
        style="position: absolute;"
        :style="$vuetify.breakpoint.smAndDown ? 'right: 16px; top: 16px;' : 'right: 25px; top: 25px;'"
        class="ma-0"
        @click="$emit('input', false)"
      >
        <v-icon
          color="black"
          size="22"
        >
          {{ $vuetify.icons['sn-icon-exit'] }}
          exit
        </v-icon>
      </v-btn>
      <v-layout
        row
        wrap
        style="height: 100%; max-width: 464px; margin: 0 auto; padding-left: 16px; padding-right: 16px;"
        :style="$vuetify.breakpoint.smAndDown ? 'padding-top: 77px;' : 'padding-top: calc(50vh - 145px);'"
        d-block
      >
        <v-flex xs12>
          <div class="sn-title-1 sn-font-condensed sn-font-weight-extra-light">
            Ready for a new loan?
          </div>
        </v-flex>
        <v-flex xs12>
          <div class="sn-headline sn-font-standard sn-font-weight-regular pt-16 pb-24">
            {{ computedNewLoanAppDialogText }}
          </div>
        </v-flex>
        <v-flex xs12>
          <v-divider class="pb-24" />
        </v-flex>
        <v-flex xs12>
          <v-checkbox
            v-model="confirmed"
            label="Confirm new loan app checkbox"
            class="ma-0 pa-0 sn-subhead sn-font-standard sn-font-weight-regular"
            color="black"
          >
            <template v-slot:label>
              <div
                class="sn-text-primary sn-subhead sn-font-standard sn-font-weight-regular"
              >
                {{ computedNewLoanAppDialogCheckbox }}
              </div>
            </template>
          </v-checkbox>
        </v-flex>
        <v-flex xs12>
          <sn-btn
            class="mt-0 mx-0 sn-title-3"
            style="margin-bottom: 8px;"
            :block="true"
            :display="true"
            :disabled="!confirmed"
            @click="$emit('confirm')"
          >
            {{ computedNewLoanAppDialogConfirmButton }}
          </sn-btn>
        </v-flex>
        <v-flex xs12>
          <sn-btn
            class="ma-0 sn-title-3"
            :block="true"
            :display="true"
            :outline="true"
            @click="$emit('input', false)"
          >
            cancel
          </sn-btn>
        </v-flex>
      </v-layout>
    </div>
  </v-dialog>
</template>

<script>
import snBtn from '~/components/snui/snBtn/snBtn.vue'

export default {
  name: 'NewLoanAppDialog',
  components: {
    snBtn
  },
  props: {
    value: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      confirmed: false
    }
  },
  computed: {
    computedNewLoanAppDialogText () {
      return this.$store?.borrowerWebContent?.newLoanAppDialogText ? this.$store.borrowerWebContent.newLoanAppDialogText : 'You are about to start an application for a new loan that will be separate from any existing or previous loans. Are you sure you want to apply for an additional loan?'
    },
    computedNewLoanAppDialogCheckbox () {
      return this.$store?.borrowerWebContent?.newLoanAppDialogCheckbox ? this.$store.borrowerWebContent.newLoanAppDialogCheckbox : 'Yes, I want to apply for a new loan'
    },
    computedNewLoanAppDialogConfirmButton () {
      return this.$store?.borrowerWebContent?.computedNewLoanAppDialogConfirmButton ? this.$store.borrowerWebContent.computedNewLoanAppDialogConfirmButton : 'start application'
    }
  }
}
</script>

<style scoped>
.pt-16 {
  padding-top: 16px;
}

.pb-24 {
  padding-bottom: 24px;
}
</style>
